export default "__VITE_ASSET__C4L16doH__"